<template>
    <div
        class="list-group-item d-inline-flex align-items-center"
        :class="preventAction ? 'border-0 px-0 disabled' : 'list-group-item-action'"
        @click="itemSelected(item)"
    >
        <div v-if="item.thumb" class="mr-3" style="height: 50px; width: 50px">
            <img :src="getThumbUrl(item.thumb)" class="img-thumbnail p-0 img-fluid h-100 w-100" alt="" />
        </div>
        <span class="mr-auto">{{ item.name }}</span>
    </div>
</template>

<script lang="ts" setup>
import { Item } from '@/components/Layers/modal/types';
import { getThumbUrl } from '@/utils/imageUtils';
const props = defineProps<{
    item: Item;
    preventAction?: boolean;
}>();

const emit = defineEmits<{
    (event: 'item-selected', value: Item): void;
}>();

const itemSelected = (item: Item) => {
    if (props.preventAction) return;
    emit('item-selected', item);
};
</script>

<style scoped>
.list-group-item-action:hover {
    font-weight: bold;
}
</style>
